import BalanceCell from '@/components/Reports/Cell/BalanceCell.vue'

const config = {
  cellRenderer: BalanceCell
}
export default {
  type: 'Balance',
  config
}
